// Screenshots of the delivered sites. Static imports so webpack fingerprints them.
import shangeit_desktop from './work/shangeit-desktop.jpg';
import shangeit_mobile from './work/shangeit-mobile.jpg';
import iwickliffe_desktop from './work/iwickliffe-desktop.jpg';
import iwickliffe_mobile from './work/iwickliffe-mobile.jpg';
import farmerboaz_desktop from './work/farmerboaz-desktop.jpg';
import farmerboaz_mobile from './work/farmerboaz-mobile.jpg';

const shots = {
  shangeit: { desktop: shangeit_desktop, mobile: shangeit_mobile },
  iwickliffe: { desktop: iwickliffe_desktop, mobile: iwickliffe_mobile },
  farmerboaz: { desktop: farmerboaz_desktop, mobile: farmerboaz_mobile },
};

export default shots;
